@if (touched) {
  @for (errorKey of Object.keys(errors); track errorKey) {
    <vitamui-form-error
      [errorMessageMap]="errorMessageMap()"
      [errorKey]="errorKey"
      [translateParams]="errors[errorKey]"
    ></vitamui-form-error>
  }
}
